
import React from "react";
import { FormControl, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface CategorySelectProps {
  value: string;
  onChange: (value: string) => void;
  categories: Array<{id: string, name: string}>;
  error?: string;
}

const CategorySelect = ({ value, onChange, categories, error }: CategorySelectProps) => {
  console.log("Rendering CategorySelect with categories:", categories);
  
  // Default categories to use if none are provided or if they fail to load
  const defaultCategories = [
    { id: "chemicals", name: "Chemicals" },
    { id: "antibodies", name: "Antibodies" },
    { id: "enzymes", name: "Enzymes" },
    { id: "biological-samples", name: "Biological Samples" },
    { id: "other", name: "Other" }
  ];
  
  // Ensure we have categories even if an empty array is passed
  const displayCategories = Array.isArray(categories) && categories.length > 0 
    ? categories 
    : defaultCategories;
  
  return (
    <div className="mb-4">
      <div className="space-y-2">
        <label className="text-sm font-medium">Category *</label>
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger className={error ? "border-red-500" : ""}>
            <SelectValue placeholder="Select a category" />
          </SelectTrigger>
          <SelectContent>
            {displayCategories.map(category => (
              <SelectItem key={category.id} value={category.id}>
                {category.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      </div>
    </div>
  );
};

export default CategorySelect;
